<template>
    <div class="MemberArea">
        <div class="MemberArea__container">
            <h1 class="MemberArea__title">Votre espace membre</h1>
            <div v-if="$user">
                <profile/>
                <member-area-nav :accommodation-enabled="accommodationEnabled" :survey-enabled="surveyEnabled" :items="navItems"/>
                <router-view/>
            </div>
        </div>
    </div>
</template>

<script>
    import {actions, getters} from "../store";
    import MemberAreaNav from "./MemberAreaNav";

    export default {
        props: ['navItems', 'surveyEnabled', 'accommodationEnabled'],
        components: {MemberAreaNav},
        created() {
            actions.fetchUser()
        }
    }
</script>
